import { useContext } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { deleteCustomReportSectionApi } from '../../../../../features/customReport/service/customReportSectionService'
import customReportQueryKeys, {
  isSectionQuery
} from '../../../../../features/customReport/queries/customReportQueryKeys'
import { CustomReportSectionsType } from '../../../../../redux/context/customReports/typesSection'
import { LayoutsContext, LayoutsContextType } from '../layout/LayoutContext'
import { showErrorMessage } from '../../../../../utils/message'

export function useDeleteSection(companyId: string | undefined, reportId: number | undefined) {
  const queryClient = useQueryClient()
  const { onSectionRemove } = useContext(LayoutsContext) as LayoutsContextType

  return async (section: CustomReportSectionsType) => {
    if (!companyId || !reportId || !section.id) return

    try {
      await deleteCustomReportSectionApi(companyId, reportId, section.id)
      onSectionRemove(section)
      queryClient.removeQueries({
        queryKey: customReportQueryKeys.sections(),
        predicate: query => isSectionQuery(query, section.id)
      })
      await queryClient.invalidateQueries({ queryKey: customReportQueryKeys.detail(companyId, reportId) })
    } catch (error) {
      showErrorMessage()
      throw error
    }
  }
}
